/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { CountryVoModel, CountyVoModel } from '@well/common-libs/country-management/domain-model';
import { CountryStore } from '../country.store';

@Injectable({
  providedIn: 'root',
})
export class CountryStoreFacade {
  private store = inject(CountryStore);

  // Signal API (new)
  readonly countriesSignal = this.store.countries;
  readonly countiesSignal = this.store.counties;

  // Observable API (backward compatible)
  countries$: Observable<CountryVoModel[]> = toObservable(this.store.countries).pipe(
    debounceTime(100),
    tap((countries) => {
      if (!countries || !countries.length) {
        this.fetchCountries();
      }
    })
  );

  counties$: Observable<CountyVoModel[]> = toObservable(this.store.counties).pipe(
    debounceTime(100),
    tap((counties) => {
      if (!counties || !counties.length) {
        this.fetchCounties();
      }
    })
  );

  fetchCountries() {
    this.store.loadCountries();
  }

  fetchCounties() {
    this.store.loadCounties();
  }
}
